import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-2266">
      <Navbar data-id="element-2267" />
      <main data-id="element-2268">
        <ConsularAffairs data-id="element-2269" />
      </main>
      <Footer data-id="element-2270" />
      <FeedbackPopup data-id="element-2271" />
    </div>;
}